
// swiper
if(!customElements.get('swiper-component-tt')) {
  customElements.define(
    'swiper-component-tt',
    class SwiperComponentsTT extends HTMLElement {
      constructor() {
        super();
        this.swiper = this.querySelector('[id^="Swiper-"]');
        this.swiperDesktop = this.dataset.swiperDesktop === "true";
        this.swiperMobile = this.dataset.swiperMobile === "true";
        this.columnsDesktop = parseFloat(this.dataset.columnsDesktop) || 3;
        this.columnsMobile = parseFloat(this.dataset.columnsMobile);
        this.spaceBetween = parseFloat(this.dataset.spaceBetween) || 0;

        console.log(this.dataset)

        if(this.initSwiper === 'false') return;
        this.swiperSlide();

        window.addEventListener('resize', () => {
          this.resetHeight(this);
          setTimeout(() => this.style.setProperty('--swiper-height', `${this.querySelector('.swiper-wrapper').offsetHeight}px`), 400);
        });
      }

      swiperSlide() {
        if (!this.swiperDesktop && window.innerWidth >= 1025) {
          return; // ডেস্কটপে Swiper চালু হবে না
        }
        if (!this.swiperMobile && window.innerWidth < 1025) {
          return; // ডেস্কটপে Swiper চালু হবে না
        }
        this.swiper = new Swiper(this.swiper, {

          slidesPerView: 1,
          spaceBetween: this.calculateSpaceBetween(),
          pagination: {
            clickable: true,
            el: this.querySelector('[id^=SwiperPagination-]'),
          },
          navigation: {
            prevEl: this.querySelector('[id^="SwiperPrev-"]'),
            nextEl: this.querySelector('[id^="SwiperNext-"]')
          },
          breakpoints: {
            769: {
              slidesPerView: this.columnsMobile,
              spaceBetween: this.calculateSpaceBetween(),
            },
            1025: {
              slidesPerView: this.columnsDesktop,
              spaceBetween: 23,
              navigation: {
                prevEl: this.querySelector('[id^="SwiperPrev-"]'),
                nextEl: this.querySelector('[id^="SwiperNext-"]')
              }
            }
          }
        });

        this.style.setProperty('--swiper-height', `${this.querySelector('.swiper-wrapper').offsetHeight}px`);
      }

      calculateSpaceBetween() {
        return this.spaceBetween.toString() === '0' ? 0 : Math.floor(this.spaceBetween / 2);
      }

      setSwiperHeight() {
        const parentElement = this;
        const mutationConfig = { attributes: true, childList: true, subtree: true };
        function onMutationChangeCallack(mutationConfigList) {
          for(const mutationConfig of mutationConfigList) {
            if(mutationConfig.type === 'attributes') {
              parentElement.resetHeight(parentElement);
              parentElement.style.setProperty('--swiper-height', `${parentElement.querySelector('.swiper-wrapper').offsetHeight}px`);
              // console.log(`${mutationConfig.attributeName} attribute changed`);
            } else if(mutationConfig.type === 'childList') {
              parentElement.resetHeight(parentElement);
              parentElement.style.setProperty('--swiper-height', `${parentElement.querySelector('.swiper-wrapper').offsetHeight}px`);
              // console.log("A child node has been added or removed.");
            } else {
              parentElement.resetHeight(parentElement);
              parentElement.style.setProperty('--swiper-height', `${parentElement.querySelector('.swiper-wrapper').offsetHeight}px`);
              // console.log("A subtree has been added or removed.");
            }
          }
        }

        const observer = new MutationObserver(onMutationChangeCallack);
        observer.observe(this.swiper, mutationConfig);
      }

      resetHeight(el) {
        return el.style.removeProperty('--swiper-height');
      }
    }
  )
}



if(!customElements.get('swiper-component')) {
  customElements.define(
      'swiper-component',
      class TestimonialsSwiperComponents extends HTMLElement {
        constructor() {
          super();
          this.swiper = this.querySelector('[id^="Swiper-"]');
          this.slides = parseFloat(this.dataset.slides);
          this.slidesMobile = parseFloat(this.dataset.slidesMobile);
          this.spaceBetween = parseFloat(this.dataset.spaceBetween);

          if(this.initSwiper === 'false') return;
          this.swiperSlide();

          window.addEventListener('resize', () => {
            this.resetHeight(this);
            setTimeout(() => this.style.setProperty('--swiper-height', `${this.querySelector('.swiper-wrapper').offsetHeight}px`), 400);
          });
        }

        swiperSlide() {
          this.swiper = new Swiper(this.swiper, {
            initialSlide: 1,
            slidesPerView: 1.1,
            spaceBetween: this.calculateSpaceBetween(),
            pagination: {
              clickable: true,
              el: this.querySelector('[id^=SwiperPagination-]'),
            },
            navigation: {
              prevEl: this.querySelector('[id^="SwiperPrev-"]'),
              nextEl: this.querySelector('[id^="SwiperNext-"]')
            },
            breakpoints: {
              769: {
                slidesPerView: this.slidesMobile,
                spaceBetween: this.calculateSpaceBetween(),
              },
              1025: {
                slidesPerView: this.slides,
                spaceBetween: this.spaceBetween,
              }
            }
          });

          this.style.setProperty('--swiper-height', `${this.querySelector('.swiper-wrapper').offsetHeight}px`);
        }

        calculateSpaceBetween() {
          return this.spaceBetween.toString() === '0' ? 0 : Math.floor(this.spaceBetween / 2);
        }

        setSwiperHeight() {
          const parentElement = this;
          const mutationConfig = { attributes: true, childList: true, subtree: true };
          function onMutationChangeCallack(mutationConfigList) {
            for(const mutationConfig of mutationConfigList) {
              if(mutationConfig.type === 'attributes') {
                parentElement.resetHeight(parentElement);
                parentElement.style.setProperty('--swiper-height', `${parentElement.querySelector('.swiper-wrapper').offsetHeight}px`);
                // console.log(`${mutationConfig.attributeName} attribute changed`);
              } else if(mutationConfig.type === 'childList') {
                parentElement.resetHeight(parentElement);
                parentElement.style.setProperty('--swiper-height', `${parentElement.querySelector('.swiper-wrapper').offsetHeight}px`);
                // console.log("A child node has been added or removed.");
              } else {
                parentElement.resetHeight(parentElement);
                parentElement.style.setProperty('--swiper-height', `${parentElement.querySelector('.swiper-wrapper').offsetHeight}px`);
                // console.log("A subtree has been added or removed.");
              }
            }
          }

          const observer = new MutationObserver(onMutationChangeCallack);
          observer.observe(this.swiper, mutationConfig);
        }

        resetHeight(el) {
          return el.style.removeProperty('--swiper-height');
        }
      }
  )
}